export const StoreGroupIds = {
  SXFUS: 34,
  SXFFR: 35,
  SXFDE: 36,
  SXFDK: 37,
  SXFES: 38,
  SXFUK: 39,
  SXFSE: 40,
  SXFNL: 41,
  SXFEU: 42,
  SXFCA: 43,
  FLUS: 16,
  FLDE: 22,
  FLUK: 23,
  FLFR: 24,
  FLES: 25,
  FLNL: 26,
  FLSE: 27,
  FLDK: 28,
  FLCA: 29,
};
